import { getNameFromOrdinal, RECIPIENT, THIRD_PARTY } from '../../../enums/bill-to-party';
import { OPERATOR_TYPE_SHIPPING_RECIPIENT_ACCOUNT, OPERATOR_TYPE_SHIPPING_THIRD_PARTY_ACCOUNT } from '../constants/filter-operator-type';

export const externalShippingAccountOperatorFromFilter = (filterValue) => {
  const [value] = filterValue;
  if (getNameFromOrdinal(Number.parseInt(value, 10)) === RECIPIENT) {
    return OPERATOR_TYPE_SHIPPING_RECIPIENT_ACCOUNT;
  }
  if (getNameFromOrdinal(Number.parseInt(value, 10)) === THIRD_PARTY) {
    return OPERATOR_TYPE_SHIPPING_THIRD_PARTY_ACCOUNT;
  }
};
